<div class="card pessoa-contato-pipeline-card" [class.collapse-closed]="!isCollapseOpened">
    <div class="card-header">
        <p class="card-title" (click)="toggleCollapse()">
            {{title}}
            <span class="badge badge-secondary-light badge-pill">
                {{contatos?.length}}
            </span>            
        </p>
    </div>

    <div class="collapse" #collapse>
        <div class="card-body" *ngIf="isLoading">
            <p class="text-center">
                <i class='fas fa-spinner fa-pulse'></i> {{isLoadingMessage}}
            </p>
        </div>
    
        <div class="card-body" *ngIf="isLoaded && (!contatos || contatos.length === 0)">
            <p class="text-center mb-0">
                {{emptyMessage}}
            </p>    
        </div>

        <div class="card-body card-body-contatos" *ngIf="isLoaded && contatos && contatos.length > 0">
            <ul class="list-group list-group-flush" [ngStyle]="{'max-height': listMaxHeight}">
                <li class="list-group-item" *ngFor="let contato of contatos"
                    [class.inativo]="isInativo(contato)"
                    (click)="open.emit(contato)">
                    <div class="list-group-item-header">
                        <small class="list-group-item-title">
                            {{contato.tipo | pessoaContatoTipo}}
                        </small>

                        <span class="{{contato.situacao | pessoaContatoSituacaoBadge}} badge-inativo" *ngIf="isInativo(contato)">
                            {{contato.situacao | pessoaContatoSituacao}}
                        </span>                        
                    </div>
                    <div class="list-group-item-body">
                        <span *ngIf="contato.nome">
                            <i class="far fa-user"></i> {{contato.nome}}
                        </span>
                        <span class="contatos-fones">
                            <span *ngIf="contato.fone">
                                <i class="fas fa-phone"></i> {{contato.fone}}
                            </span>
                            <span *ngIf="contato.celular">
                                <i class="fas fa-mobile-alt"></i> {{contato.celular}}
                            </span>
                        </span>
                        <span *ngIf="contato.email">
                            <i class="far fa-envelope"></i> {{contato.email}}
                        </span>
                    </div>                                        
                </li>          
            </ul>            
        </div>

        <div class="card-footer">
            <sgt-pessoa-contato-dropdown-insert
                [dropup]="true"
                classBtn="btn-light"
                (insert)="insertContato.emit($event)">
            </sgt-pessoa-contato-dropdown-insert>
        </div>      
    </div>
</div>